import { render, staticRenderFns } from "./EditFavNote.vue?vue&type=template&id=20846d08&scoped=true"
import script from "./EditFavNote.vue?vue&type=script&lang=js"
export * from "./EditFavNote.vue?vue&type=script&lang=js"
import style0 from "./EditFavNote.vue?vue&type=style&index=0&id=20846d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20846d08",
  null
  
)

export default component.exports